export const config = {
    meta: {
        crew: 'stat',
        page: 'child-attendance',
        name: 'KinderConnectCaptureSettings',
        submit: {
            text: 'Save',
            requiredAdditionalData: [
                { name: 'siteId', type: 'string' },
                { name: 'enabledChildIds', type: 'string[]' },
            ],
            successMessage: '',
            type: 'none',
            formType: 'submit',
        },
    },
    title: 'KinderConnect capture settings',
    modalWidth: 'Big',
    version: 3,
    rows: [[{ type: 'custom-row', name: 'childCaptureList' }], [{ type: 'notice', name: 'captureConsequences' }]],
};
